<template>
  <base-layout
    page-default-back-link="/home"
    showUserSettings="true"
    showSettings="true"
  >
    <!-- Search Module  -->
    <div v-if="status == 'Search'">
      <ion-grid>
        <ion-row>
          <ion-col size="12" size-md="6">
            <ion-searchbar
              placeholder="Search"
              @ionChange="get_products"
              debounce="1000"
              v-model="term"
            ></ion-searchbar>
          </ion-col>
          <ion-col size="12" size-md="6">
            <ion-select
              interface="popover"
              :value="searchConnection"
              @ionChange="connectionFilterFn"
            >
              <ion-select-option
                :value="item"
                v-for="(item, index) in connectionsList"
                :key="index"
                >{{ item }}
              </ion-select-option>
            </ion-select>
          </ion-col>
        </ion-row>
      </ion-grid>

      <div v-if="error!==''" class="login_error ion-text-center">{{ error }}</div>

      <ion-list class="results">
        <ion-item v-for="(product, index) in products" :key="product.prod_id">
          <ion-grid>
            <ion-row>
              <ion-col size="4" size-md="3">
                <ion-label> SKU: </ion-label> {{ product.pitem_code }}
              </ion-col>
              <ion-col size="8" size-md="5">
                <ion-label> Name: </ion-label> {{ product.prod_name }}
              </ion-col>
              <ion-col size="12" size-md="4">
                <ion-label>by</ion-label>
                {{ product.ent_fullname }}
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" size-md="8">
                <ion-label> Dimension: </ion-label>
                {{ product.pitem_dimension }}
                <br /><br />
                <ion-label> Price: </ion-label>
                ${{ product.pitem_price_designer }} / {{ product.pitem_unit }}
              </ion-col>
              <ion-col size="12" size-md="4" class="ion-text-right">
                <!-- <ion-button size="small" @click="show_product(index)">
                  <ion-icon :icon="eyeOutline"></ion-icon> Open
                </ion-button>
                <ion-button size="small" @click="product_options(product.pitem_id)">
                  <ion-icon :icon="ellipsisVerticalOutline"></ion-icon>
                </ion-button> -->
                <ion-button @click="openPopover($event, pitem_id, index)"><ion-icon :icon="ellipsisVerticalOutline"></ion-icon></ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>

          <!--               <ion-label>

                   <ion-grid>
                        <ion-row>
                            <ion-col>
                                <ion-label> {{product.prod_name}} </ion-label>
                                <br><br>
                                <ion-label> {{product.pitem_code}} </ion-label>
                            </ion-col>
                            <ion-col>
                                <ion-button @click="show_product(index)">
                                    <ion-icon :icon="eyeOutline"></ion-icon> Open
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-grid>

              </ion-label> -->
        </ion-item>
      </ion-list>


      <div v-if="show_scroll">
        <ion-infinite-scroll
          @ionInfinite="loadData($event, true)"
          threshold="100px"
          id="infinite-scroll"
          :disabled="false"
        >
          <ion-infinite-scroll-content
            loading-spinner="bubbles"
            loading-text="Loading more data..."
          >
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </div>
    </div>

    <!-- View product's Information Module  -->
    <div v-if="status == 'Product_Information'">
      <br>
      <div class="ion-text-right">
        <ion-button size="small" @click="back_to_search()">Back</ion-button>
      </div>
      <br>
      <div class="ion-text-right">
        <span class="product_information_message">{{product_information_message}}</span>
      </div>
      <br>
      <div class="information">
        <ion-grid>
          <ion-row>
            <ion-col size="7">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="12" size-md="4">
                  <ion-label>Vendor: </ion-label><br />
                  {{ selected_product.ent_fullname }}
                </ion-col>
                <ion-col size="12" size-md="4">
                  <ion-label>SKU: </ion-label><br />
                  {{ selected_product.pitem_code }}
                </ion-col>
                <ion-col size="12" size-md="4">
                  <ion-label>Name: </ion-label><br />
                  {{ selected_product.prod_name }}
                </ion-col>
              </div>
            </ion-col>
            <ion-col size="5" class="ion-text-right">
              <img :src="selected_product.image_url" style="max-width:100%;max-height:25vh;" />
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12" size-md="6">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="3">
                  <ion-label>Price: </ion-label>
                </ion-col>
                <ion-col size="9">
                  ${{ selected_product.pitem_price_designer }} /
                  {{ selected_product.pitem_unit }}
                </ion-col>
              </div>
            </ion-col>
            <ion-col size="12" size-md="6">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="12">
                  <ion-label>Dimesions: </ion-label><br /><br />
                  <span>{{ selected_product.pitem_dimension }}</span><br>
                  <span>{{ selected_product.pitem_dimension_metric }}</span>
                </ion-col>
              </div>
            </ion-col>
            <ion-col size="12" size-md="6">
              <div style="display: flex; flex-wrap: wrap">
                <ion-col size="12">
                  <ion-label>Description: </ion-label><br /><br />
                  <span v-html="selected_product.prod_desc"></span><br>
                  <span v-html="selected_product.pitem_description"></span>
                </ion-col>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>

        <ion-grid v-if="(selected_product.total_qty>0 || selected_product.total_backordered_qty>0) && selected_product.is_textile">
          <ion-row style="border-left: 10px solid blue;">
            <ion-col size="12" size-md="6">
              <span>
                <ion-label>Total Qty: </ion-label>
                <span>{{selected_product.total_qty}}</span><br>
                <div v-if="selected_product.total_backordered_qty>0">
                <ion-label>Backordered: </ion-label>
                <span>{{selected_product.total_backordered_qty}}</span><br>
                </div>
              </span>
            </ion-col>
          </ion-row>
          <div v-for="(location, index) in selected_product.locations" :key="index">
          <ion-row style="border-left: 10px solid blue;"  v-if="location.qty>0">
              <ion-col size="12" size-md="6" >
                  <div>
                  <ion-button size="small" fill="clear" style="padding:0px;color:black;" @click="location.show_rolls=!location.show_rolls">
                    <span style=""><strong>{{location.name}}</strong> - {{location.qty}}</span>&nbsp;<ion-icon slot="end" :icon="eyeOutline"></ion-icon>
                  </ion-button>
                  </div>
                  <span v-if="location.show_rolls">
                    <ion-list style="margin-top:0px;">
                      <ion-item style="vertical-align:top;" v-for="invItem in location.availability" :key="invItem.inv_id">
                        &bull;&nbsp;Dye Lot: {{invItem.inv_dyelot}}:
                        <ul>
                           <li>Available: {{invItem.available}}</li>
                           <li>Reserved: {{invItem.reserved}}</li>
                        </ul>
                      </ion-item>
                    </ion-list>
                  </span>
              </ion-col>
          </ion-row>
          </div>
        </ion-grid>
      </div>
      <div class="ion-text-right">
        <ion-button size="small" @click="add_to_visit_from_product()">Add to Visit</ion-button>
      </div>

    </div>
  </base-layout>
</template>

<script>
import {
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonLabel,
  IonList,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonIcon,
  IonSearchbar,
  IonSelect,
  IonSelectOption,
  modalController,
  popoverController,
  loadingController
} from "@ionic/vue";
import { searchOutline, eyeOutline, ellipsisVerticalOutline } from "ionicons/icons";
import ProductOptionsPopover from '../components/products/ProductOptionsPopover.vue';
import SelectVisit from "../components/SelectVisit.vue";

export default {
  components: {
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonItem,
    IonLabel,
    IonList,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    IonIcon,
    IonSearchbar,
    IonSelect,
    IonSelectOption
  },

  data() {
    return {
      status: "Search",

      searchConnection: '- All -',
      connectionsList: ['- All -'],
      connectionsListWithCode: [{ conn_id: 0, conn_name: '- All -' }],

      term: "",
      limit: 20,
      offset: 0,
      show_scroll: false,

      error: "",
      products: [],
      selected_product: "",
      product_information_message: "",

      searchOutline,
      eyeOutline,
      ellipsisVerticalOutline

    };
  },

  methods: {
    get_products() {
      this.products = []; // empty result
      (this.limit = 20), (this.offset = 0), (this.show_scroll = true);
      this.loadData(this.$event, false);
    },

    connectionFilterFn({ detail }) {
      console.log(detail);
      this.searchConnection = detail.value;
      this.products = []; // empty result
      (this.limit = 20), (this.offset = 0), (this.show_scroll = true);
      this.loadData(this.$event, false);
    },

    async loadData(event, call_event) {
      console.log("Load data");

      const loading = await loadingController
        .create({
          cssClass: 'my-custom-class',
          message: 'Please wait...',
        });

      await loading.present();

      let conn_id = 0;
      for (let i = 0; i < this.connectionsListWithCode.length; i++) {
        if (this.connectionsListWithCode[i].conn_name == this.searchConnection) {
          conn_id = this.connectionsListWithCode[i].conn_id;
        }
      }

      await this.$store.dispatch("products/products_search", {
        term: this.term,
        limit: this.limit,
        offset: this.offset,
        conn_id: conn_id,
      });
      this.offset += this.limit; // prepare for next use
      var error = this.$store.getters["products/getRequestError"];

      if (error != "") {
        this.error = error;
      } else {
        let received_products = this.$store.getters["products/getProducts"];
        for (let i = 0; i < received_products.length; i++) {
          received_products[i].show_rolls = false;
          this.products.push(received_products[i]);
        }

        if (received_products.length < this.limit) {
          this.show_scroll = false;
        }

        this.error = "";
      }
      loading.dismiss();

      if (call_event) event.target.complete();
    },

    // async product_options(pitem_id){

    //   const modal = await modalController.create({
    //     component: ProductOptions,
    //     componentProps: {
    //       pitem_id: pitem_id,
    //     },
    //   });

    //   var currentComponent = this;
    //   modal.onDidDismiss().then((modelData) => {
    //     if (modelData !== null) {
    //       if(modelData.data!='cancelled'){
    //         // currentComponent.search_scanned_product(modelData.data);
    //         currentComponent.product_information_message = modelData.data;
    //       }
    //     }
    //   });
    //   return modal.present();

    // },

    async openPopover(ev, pitem_id, index) {
      console.log(pitem_id);
      console.log(index);
        const popover = await popoverController
          .create({
            component: ProductOptionsPopover,
            cssClass: 'my-custom-class',
            event: ev,
            translucent: true
          })

        var currentComponent = this;
        popover.onDidDismiss().then((modelData) => {
          if (modelData !== null) {
            if(modelData.data=='open_product'){
              currentComponent.show_product(index);
            } else if(modelData.data=='add_to_visit'){
              currentComponent.add_to_visit_from_list(index);
            }
          }
        });
        await popover.present();

    },

    async show_product(index) {

      const loading = await loadingController
        .create({
          cssClass: 'my-custom-class',
          message: 'Please wait...',
        });

      await loading.present();

      var ref = this;

      await this.$store.dispatch("products/product", {
          pitem_id: this.products[index].pitem_id,
          master_conn_id: this.products[index].master_conn_id
        }).then(response => {
          ref.error = '';
          ref.selected_product = response.data.product;
          console.log(this.selected_product);
          ref.product_information_message = '';
          ref.status = "Product_Information";
      }, request_error => {
          ref.error = request_error;
      })

      loading.dismiss();

    },

    back_to_search() {
      const { pitem_id } = this.$route.params;
      if (pitem_id > 0) {
        this.$router.push({ name:'Scan', params:{ open_scan:0 }});
      } else {
        this.status = "Search"; // Stay in the current page.
      }
    },

    add_to_visit_from_list(index){

        let tearsheet_enabled=false;
        if(this.products[index].choices.includes('[Tearsheet]')){
          tearsheet_enabled = true;
        }
        let memo_enabled=false;
        if(this.products[index].choices.includes('[Sample]')){
          memo_enabled = true;
        }
        let quote_enabled=false;
        if(this.products[index].choices.includes('[Quote]')){
          quote_enabled = true;
        }


        let tearsheet_active=false;
        let memo_active=false;
        let quote_active=false;
        if (this.products[index].ptype_id==1 || this.products[index].ptype_id==2 || this.products[index].ptype_id==5 || this.products[index].ptype_id==8) {
          tearsheet_active=true;
          memo_active=false;
          quote_active=false;
        }
        if (this.products[index].ptype_id==3 || this.products[index].ptype_id==4 || this.products[index].ptype_id==7 || this.products[index].ptype_id==6) {
          tearsheet_active=true;
          memo_active=true;
          quote_active=false;
        }

        this.call_for_visits(tearsheet_enabled, memo_enabled, quote_enabled, this.products[index].pitem_id, tearsheet_active, memo_active, quote_active);
    },

    add_to_visit_from_product(){

        let tearsheet_enabled=false;
        if(this.selected_product.choices.includes('[Tearsheet]')){
          tearsheet_enabled = true;
        }
        let memo_enabled=false;
        if(this.selected_product.choices.includes('[Sample]')){
          memo_enabled = true;
        }
        let quote_enabled=false;
        if(this.selected_product.choices.includes('[Quote]')){
          quote_enabled = true;
        }

        let tearsheet_active=false;
        let memo_active=false;
        let quote_active=false;
        if (this.selected_product.ptype_id==1 || this.selected_product.ptype_id==2 || this.selected_product.ptype_id==5 || this.selected_product.ptype_id==8) {
          tearsheet_active=true;
          memo_active=false;
          quote_active=false;
        }
        if (this.selected_product.ptype_id==3 || this.selected_product.ptype_id==4 || this.selected_product.ptype_id==7 || this.selected_product.ptype_id==6) {
          tearsheet_active=true;
          memo_active=true;
          quote_active=false;
        }

        this.call_for_visits(tearsheet_enabled, memo_enabled, quote_enabled, this.selected_product.pitem_id, tearsheet_active, memo_active, quote_active);
    },

    async call_for_visits(tearsheet_enabled, memo_enabled, quote_enabled, pitem_id, tearsheet_active, memo_active, quote_active){

        // request for InProgress visits
        await this.$store.dispatch("visits/request_for_visits", {
            term: '',
            limit: 0,
            offset: 0,
            status: 'InProgress',
            getAllVisits: false
        });
        var req_error = this.$store.getters["visits/getRequestError"];

        if (req_error != "") {
            this.error = req_error;
        } else {
            this.error = "";
            let received_visits = this.$store.getters["visits/getAllVisits"];

            for(let i=0; i<received_visits.length; i++){
                received_visits[i].tearsheet_checked = tearsheet_active;
                received_visits[i].memo_checked = memo_active;
                received_visits[i].quote_checked = quote_active;
                received_visits[i].item_notes = '';
            }

            const modal = await modalController.create({
            component: SelectVisit,
            componentProps: {
                visits: received_visits,
                tearsheet_enabled:tearsheet_enabled,
                memo_enabled:memo_enabled,
                quote_enabled:quote_enabled,
                tearsheet_active:tearsheet_active,
                memo_active:memo_active,
                quote_active:quote_active
            },
            });

            var currentComponent = this;
            modal.onDidDismiss().then((modelData) => {
            if (modelData !== null) {
                if(modelData.data!='cancelled'){
                    // currentComponent.search_scanned_product(modelData.data);
                    console.log('Visit selected')

                    var selected_options = "";
                    if (modelData.data.tearsheet_checked) {
                        selected_options += "[TEARSHEET]";
                    }
                    if (modelData.data.memo_checked) {
                        selected_options += "[SAMPLE]";
                    }
                    if (modelData.data.quote_checked) {
                        selected_options += "[QUOTE]";
                    }

                    currentComponent.$store.dispatch("visits/visit_add_item", {
                        flvis_id: modelData.data.flvis_id,
                        flvisi_type: 0, // product
                        pitem_id: pitem_id,
                        inv_id: 0,
                        options: selected_options,
                        options_details: "",
                        flvisi_notes: modelData.data.item_notes
                    }).then( () => {
                        console.log('Item added successfully');
                    }, request_error => {
                        currentComponent.error = request_error;
                    })

                }
            }
            });
            return modal.present();

        }
    }

  },
  ionViewDidEnter() {
    console.log(" Ion did enter. ",this.$route.params);

    const { pitem_id, master_conn_id } = this.$route.params;
    var ref = this;

    if (pitem_id > 0) {
      //this.selected_product = this.$store.getters["visits/getItemFromScan"];

      this.$store.dispatch("products/product", {
          pitem_id: pitem_id,
          master_conn_id: master_conn_id
        }).then(response => {
          ref.error = '';
          ref.selected_product = response.data.product;
          console.log(this.selected_product);
          ref.product_information_message = '';
          ref.status = "Product_Information";
      }, request_error => {
          ref.error = request_error;
      })

    } else {
      this.status = "Search";

      this.searchConnection = '- All -';
      this.connectionsList = ['- All -'];
      this.connectionsListWithCode = [{ conn_id: 0, conn_name: '- All -' }]

      this.$store.dispatch("various/connections").then( response => {
        if(response.data.success){
            for(let i=0; i<response.data.results.length; i++){
              ref.connectionsList.push(response.data.results[i].conn_name);
              ref.connectionsListWithCode.push(response.data.results[i]);
            }
            ref.searchConnection = ref.connectionsListWithCode[0].conn_name
          } else {
            ref.error = response.message;
          }
      }, request_error => {
          ref.error = request_error;
      })

    }

  },
};
</script>

<style lang="scss" scoped>
.results {
  .conf-name {
    color: #000;
  }

  ion-row {
    background: #ffffff;
    /*     margin-bottom: 10px; */
    padding: 10px;
    border-left: 10px solid #226391;
    height: auto;
  }

  .no-date {
    font-style: italic;
  }

  a {
    text-decoration: none;
  }

  ion-grid {
    height: auto;
  }

  ion-item {
    border: none;
    padding: 0px;
  }

  .item-native {
    padding: 0px;
    padding-inline: 0px;
  }

  .item-inner {
    padding: 0px;
    padding-inline: 0px;
    border: none;
  }

  ion-label {
    font-size: 0.8em;
    font-weight: bold;
    color: #444;
  }
}

.information {

  font-size:0.9em;

  .conf-name {
    color: #000;
  }

  ion-row {
    background: #ffffff;
/*     margin-bottom: 10px; */
    padding: 10px;
    border-left: 10px solid #079602;
    height: auto;
  }

  .no-date {
    font-style: italic;
  }

  a {
    text-decoration: none;
  }

  ion-grid {
    height: auto;
  }

  ion-item {
    border: none;
  }

  ion-label {
    font-size: 0.8em;
    font-weight: bold;
    color: #444;
  }

  ion-list {
    margin-top: 20px;
    background: transparent;
    border-radius: 8px;
  /*       border: 1px solid #333; */
    ion-item {
      --background: transparent;
      --border-color: transparent;
      font-size: 0.85em;
    }
  }

}



.login_error {
  color: red;
  font-size: 15px;
}

.product_information_message {
  color:green;
}
</style>